export function getAddToCartRoute(state, entity) {
    return {
        method: 'POST',
        path: `/api/checkout/v0/${state.core.siteId}/carts/items`,
        entity: entity
    };
}
